import Vue from 'vue'
import App from './App.vue'

import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue'

Vue.use(LayoutPlugin)

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from 'bootstrap-vue'

Vue.use(ModalPlugin)

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue'

Vue.use(CardPlugin)

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from 'bootstrap-vue'

Vue.use(VBScrollspyPlugin)

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue'

Vue.use(DropdownPlugin)
Vue.use(TablePlugin)
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

Vue.config.productionTip = false
// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask);

import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6LddFrwUAAAAAMFfLFE6xR1dWrLHJPnBwh08QpcN' })
import VueSocketIO from 'vue-socket.io'

import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
const socket = io('https://ws.retailcreditcloudapi.net/');
Vue.use(VueSocketIOExt, socket);

import VueSpinners from 'vue-spinners'
Vue.use(VueSpinners)

Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')
